module.exports = __webpack_public_path__ + "static/media/17.a78ef8e1.png";